import React, { Fragment } from 'react';
import Logo from '../../../assets/images/logo-full.png'
const Header = ({order}) => {
    if (order){
        return (
            <header className="bg-lightest bb-1 pt-5 pb-4 px-20">
                <div className="row">
                    <div className="col-3 pt-4 text-center">
                        <img className="col-9" alt="Zapay Logo" src={Logo} />
                    </div>
                    <div className="col-9">
                        <div className="row">
                            <div className="col-3 px-0 mb-3">
                                <h6 className="text-muted mb-1">Cliente</h6>
                                <p className="text-muted">{order.customer.name}</p>
                            </div>
                            <div className="col-3 px-0">
                                <h6 className="text-muted mb-1">CPF/CNPJ</h6>
                                <p className="text-muted">{order.customer.document}</p>
                            </div>
                            <div className="col-3 px-0">
                                <h6 className="text-muted mb-1">Protocolo</h6>
                                <p className="text-muted">{order.protocol}</p>
                            </div>
                            <div className="col-3 px-0">
                                <h6 className="text-muted mb-1">Data</h6>
                                <p className="text-muted">{order.createdAt}</p>
                            </div>
                            <div className="col-3 px-0">
                                <h6 className="text-muted mb-1">Telefone</h6>
                                <p className="text-muted">{order.customer.phone}</p>
                            </div>
                            <div className="col-3 px-0">
                                <h6 className="text-muted mb-1">Email</h6>
                                <p className="text-muted">{order.customer.email}</p>
                            </div>
                            { order.customer.licensePlate &&
                                <div className="col-3 px-0">
                                    <Fragment>
                                        <h6 className="text-muted mb-1">Placa</h6>
                                        <p className="text-muted">{order.customer.licensePlate}</p>
                                    </Fragment>
                                </div>
                            }
                            { order.customer.renavam &&
                                <div className="col-3 px-0">
                                    <Fragment>
                                        <h6 className="text-muted mb-1">RENAVAM</h6>
                                        <p className="text-muted">{order.customer.renavam}</p>
                                    </Fragment>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </header>
        );
    };
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Pages/Receipt/Header.js